
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Clienti.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Modules/Clienti.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 06/02/25, 11:28;
 *
 *
 */

import {CampoAggiuntivo} from "../../app/shared/models/campo-aggiuntivo";
import {Azienda} from "../../app/Admin/models/Azienda";
import {FormAziendaComponent} from "../../app/Admin/form-azienda/form-azienda.component";

export var Clienti = (qs?:string, idB2b?:number, idB2c?:number, hasSede?:boolean, hasRef: boolean = true) => {

  var tipi = [
    {id:idB2b, label: 'B2B'},
    {id:idB2c, label: 'B2C'}
  ];

  function isClienteB2b(x: any) {
    return !!x.tipi?.find(t => t == idB2b);
  }

  function isClienteB2c(x: any) {
    return !!x.tipi?.find(t => t == idB2c);
  }

  function isCliFor(ruolo: 'C' | 'F', x: Azienda){

    return (x.ruoliObject?.map(r=>r.id) ?? x.ruoli ?? []).includes(ruolo) || x['ruoloappoggio']?.toUpperCase() == ruolo
  }


    var env = {
        Modules: {
            "Clienti": true,
            "Admin": true,
        },
        Menu: [
            {
                module: "Clienti",
                path: `/listautenti/aziende/c${qs ?? ''}`,
                title: 'Clienti',
                icon: "mdi mdi-account-multiple",
                capacita: ["menu-clienti"]
            },
        ],
         ClientiAddOn: {
          initialize:(cliente, Component: FormAziendaComponent)=>{
            if(cliente.referenti?.length){
              var refP = cliente.referenti.find(r=>r.principale || cliente.referenti.length == 1);
              Object.getOwnPropertyNames(refP).forEach(d=>{
                cliente[d+'Referente'] = refP[d];
              })
            }
            console.log("Cliente",cliente);
            return cliente;
          },
           map:(cliente, a,component:FormAziendaComponent)=>{
              if(!Object.getOwnPropertyNames(cliente).filter(x=>x.endsWith('Referente')).some(x=>cliente[x])) return cliente;
              if(cliente.referenti?.length){
                var refP = cliente.referenti.find(r=>r.principale || cliente.referenti.length == 1);
                Object.getOwnPropertyNames(cliente).filter(x=>x.endsWith('Referente')).forEach(d=>{
                  refP[d.replace('Referente','')] = cliente[d];
                  //refP['principale'] = true;
                })
                console.log("is not new ref", refP);
              }else{
                var newRef: any = {}
                Object.getOwnPropertyNames(cliente).filter(x=>x.endsWith('Referente')).forEach(d=>{
                  newRef[d.replace('Referente','')] = cliente[d];
                })
                newRef.principale = true;
                cliente.referenti = [newRef]
                console.log("is new ref");
              }
              console.log("Cliente out",cliente);
             console.log("New ref",newRef);

              return cliente;
           },
           SezioniInfo:[
             {
               sezione: "Anagrafica",
               hideif:{func: (x)=>  isCliFor('C',x)},
               campi:[
                 CampoAggiuntivo.SingleDropdown("Categoria", "tipi", tipi, 'label', {}, 'col-lg-3', (x)=>!!idB2b && !!idB2c && isCliFor('C',x),{
                   singleSelection:true,
                   singleOutput:false
                 } ),
                 CampoAggiuntivo.TextField("Nome *", 'nominativo', 'col-lg-3', {required: true, hideif:{func: (x)=>isClienteB2c(x) && isCliFor('C',x)}}),
                 CampoAggiuntivo.TextField("Cognome *", 'cognome', 'col-lg-3', {required: true, hideif:{func: (x)=>isClienteB2c(x) && isCliFor('C',x)}}),
                 CampoAggiuntivo.TextField("Nominativo / Ragione Sociale *", 'nominativo', 'col-lg-3', {required: true, hideif:{func:(x)=> (!idB2b || !x.tipi?.length || isClienteB2b(x)) && isCliFor('C',x) }}),
                 CampoAggiuntivo.TextField("Email", 'email','col-lg-3', {hideif:{func: (x)=>  isCliFor('C',x)}, required:true}),
                 CampoAggiuntivo.TextField("Pec", "pec",'col-lg-3', {hideif:{func:(x)=> isClienteB2b(x) && isCliFor('C',x)}}),
                 CampoAggiuntivo.TextField("Telefono", 'telefono','col-lg-3', {hideif:{func: (x)=>  isCliFor('C',x)}}),
                 CampoAggiuntivo.TextField("Partita IVA/Codice fiscale", "piva", 'col-lg-3', {hideif:{func: (x)=> (!idB2b || isClienteB2b(x) )&& isCliFor('C',x)}}),
                 CampoAggiuntivo.TextField("Codice Fiscale", "cf",'col-lg-3', {hideif:{func: (x)=>  isCliFor('C',x) && idB2c}}),
                 ...(hasSede ? [
                   CampoAggiuntivo.TextField("Indirizzo", "indirizzo",'col-lg-3', {hideif:{func: (x)=>  isCliFor('C',x)}}),
                   CampoAggiuntivo.TextField("Cap", "cap",'col-lg-3', {hideif:{func: (x)=>  isCliFor('C',x)}}),
                   CampoAggiuntivo.TextField("Città", "citta",'col-lg-3', {hideif:{func: (x)=>  isCliFor('C',x)}}),
                   CampoAggiuntivo.TextField("Provincia", "provincia",'col-lg-3', {hideif:{func: (x)=>  isCliFor('C',x)}})

                 ] : [])


               ]
             },
             ...(hasRef ? [
             {
               sezione: "Referente",
               hideif:{func:(cliente)=>isClienteB2b(cliente),},
               campi:[
                 {...CampoAggiuntivo.TextField("Nome", "nomeReferente")},
                 {...CampoAggiuntivo.TextField("Cognome", "cognomeReferente")},
               ]
             }]:[])
           ],
            codAdhoc: false,
            enable: false,
            info: false,
            commerciale: false,
            segnalatore: false,
            segnalatoreInterno: false,
            sedi: false,
            TipoSedePrimaria: false,
            attivita: false,
            geolocalizzazione: false,
            ruolo: true,
            Modifica: false,
            prodotti: false,
            rma: false,
            accesso: false,
            referenti: false,
            interventi: false,
            note_private: false,
            rating: false,
            ruoliAccesso: false,
            compilazione: false,
            luogoNascita: false,
            dataNascita: false,
            statoCivile: false,
            titoloStudio: false,
            occupazione: false,
            invalidita: false,
            legge104: false,
            diagnosi: false,
            accompagnamento: false,
            pensione: false,
            tutelare: false,
            medico: false,
            telMedico: false,
            terapia: false
        },
    };
    return env;
}
